<template>
    <div>
        <div :class="{ 'header':$route.name === 'Newhome','shadow':isShadow,'header shadow': $route.name === 'List' || $route.name === 'About' || $route.name === 'Register' || $route.name === 'Operator' || $route.name === 'Online' || $route.name === 'DarenAttestation' || $route.name === 'DarenResult' || $route.name === 'DarenSelect' || $route.name === 'EnterpriseAttestation' || $route.name === 'EnterpriseResult' || $route.name === 'Detail' || $route.name === 'Investment'}">
            <div class="box1200">
                <div class="logo fl"><router-link to="/" title="回到首页"><img :src="pcLogo"></router-link></div>
                <div class="fr">
                <div class="nav fl">
                    <ul>
                        <li class="item"><router-link to="/" :class="{active: $route.name === 'Newhome'}">首页</router-link></li>
                        <li class="item"><router-link to="/list" :class="{active: $route.name === 'List' || $route.name === 'Detail'}">任务大厅</router-link></li>
                        <li class="item"><router-link to="/Investment" :class="{active: $route.name === 'Investment'}">招商加盟</router-link></li>
                        <li class="item"><router-link to="/about" :class="{active: $route.name === 'About'}">关于我们</router-link></li>
                    </ul>
                </div>
                <!--未登录-->
                <div class="login-btn fr"><a v-if="!this.$store.state.code  || !this.$store.state.openid" class="goto" @click="login"><i class="el-icon-user-solid"></i>登录/注册</a></div>
                <!--游客身份-->
                    <div class="tourist relative fr" v-if="this.$store.state.openid && this.$store.state.user_type === 3 && !this.$store.state.is_auth">
                        <span class="logged-line"></span>
                        <router-link to="/operator" class="goto"><i class="el-icon-s-custom"></i>运营登录</router-link>
                        <router-link to="/register" class="goto"><i class="el-icon-s-order"></i>立即认证</router-link>
                        <span class="goto" @click="loginOut"><i class="el-icon-switch-button"></i>退出</span>
                    </div>
                <!--企业身份-->
                <div class="logged relative fr" v-if="this.$store.state.user_type === 0" @mouseenter="userOperateShow" @mouseleave="userOperateHide">
                    <span class="logged-line"></span>
                    <span class="user relative" v-if="enterprise_logo"><img :src="enterprise_logo"><i class="isNew absolute" v-if="is_new == 1"></i></span>
                    <span class="user relative" v-if="!enterprise_logo"><img src="@/assets/images/default-head.jpg"></span>
                    <transition name="el-fade-in">
                    <!--已提交资料未审核-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 0">
                        <li><span class="ellipsis">{{ep_name}}</span></li>
                        <li><router-link to="/enterprise-register/result">查看认证结果</router-link></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    <!--通过认证-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 1">
                        <li><span class="ellipsis">{{ep_name}}</span></li>
                        <li><router-link to="/enterprise/manage">管理首页</router-link></li>
                        <li><router-link to="/enterprise/info">企业信息</router-link></li>
                        <li><router-link to="/enterprise/order">我的推广</router-link></li>
                        <li v-if="this.$store.state.rank > 1"><router-link to="/enterprise/reward">奖励管理</router-link></li>
                        <li><router-link to="/enterprise/account">运营账号</router-link></li>
                        <li><router-link to="/enterprise/use">使用指南</router-link></li>
                        <li><router-link to="/enterprise/message" class="flex align-items">消息中心 <i class="isNew" v-if="is_new == 1"></i></router-link></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    <!--未通过认证-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 2">
                        <li><span class="ellipsis">{{ep_name}}</span></li>
                        <li><span style="color: #FF741F;">很抱歉，认证审核不通过！</span></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    </transition>
                </div>
                <!--达人身份-->
                <div class="logged relative fr" v-if="this.$store.state.user_type === 1" @mouseenter="userOperateShow" @mouseleave="userOperateHide">
                    <span class="logged-line"></span>
                    <span class="user relative" v-if="head_img"><img :src="head_img"><i class="isNew absolute" v-if="is_new == 1"></i></span>
                    <span class="user relative" v-if="!head_img"><img src="@/assets/images/default-head.jpg"></span>
                    <transition name="el-fade-in">
                    <!--已提交资料未审核-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 0 && this.$store.state.auth_type === 1">
                        <li><span class="ellipsis">{{daren_name}}</span></li>
                        <li><router-link to="/daren-register/result">查看认证结果</router-link></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    <!--未培训-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 0 && this.$store.state.auth_type === 0">
                        <li><span class="ellipsis">{{daren_name}}</span></li>
                        <li><router-link to="/daren-register/select">培训认证</router-link></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    <!--通过认证完成新手任务-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 1 && this.$store.state.newbie_task === 1">
                        <li><span class="ellipsis">{{daren_name}}</span></li>
                        <li><router-link to="/daren/manage">管理首页</router-link></li>
                        <li><router-link to="/daren/info">达人信息</router-link></li>
                        <li><router-link to="/daren/order">我的订单</router-link></li>
                        <li v-if="this.$store.state.is_agent === 1"><router-link to="/daren/agent">代客下单</router-link></li>
                        <li><router-link to="/daren/use">使用指南</router-link></li>
                        <li><router-link to="/daren/message" class="flex align-items">消息中心 <i class="isNew" v-if="is_new == 1"></i></router-link></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    <!--通过认证未完成新手任务-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 1 && this.$store.state.newbie_task === 0">
                        <li><span class="ellipsis">{{daren_name}}</span></li>
                        <li><router-link to="/daren-register/result">完成新手任务</router-link></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    <!--未通过认证-->
                    <ul class="user-operate absolute" v-show="isOperate" v-if="this.$store.state.is_auth === 2">
                        <li><span class="ellipsis">{{daren_name}}</span></li>
                        <li><span style="color: #FF741F;">很抱歉，认证审核不通过！</span></li>
                        <li @click="loginOut"><span>退出登录</span></li>
                    </ul>
                    </transition>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import {
    epInfo,
    myDarenInfo,
    addBusiness,
    newsData,
    gethomepc
} from '@/config/api.js'
export default {
    name: 'PublicHeader',
    inject:['goLogin'],
    data () {
        return {
            ep_name: '',
            enterprise_logo: '',
            daren_name: '',
            head_img: '',
            is_auth: '',
            is_official: '',
            is_agent: null,
            user_id: null,
            newbie_task: '',
            rank: '',
            auth_type: '',
            dialogVisible: false,
            isOperate: false,
            isShadow: false,
            form: {
                name: '',
                nickname: '',
                telephone: '',
                area: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: '请输入您的称呼', trigger: 'blur' }
                ],
                telephone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' }
                ],
                area: [
                    { required: true, message: '请输入意向加盟区域', trigger: 'blur' }
                ],
            },
            is_new: null,
            pcLogo: ''
        }
    },
    methods: {
        getInfo () {
            if (this.$store.state.user_type === 0) {
                let data = {
                    ep_id:this.$store.state.user_id,
                    user_type: this.$store.state.user_type,
                };
                this.$post(epInfo, data)
                    .then(res => {
                        let data = res.data;
                        this.ep_name = data.name;
                        this.enterprise_logo = data.enterprise_logo;
                        this.is_auth = Number(data.is_auth);
                        this.rank = Number(data.rank);
                        this.is_official = Number(data.is_official);
                        this.$store.commit('changeIsAuth',this.is_auth);
                        this.$store.commit('changeRank',this.rank);
                        this.$store.commit('changeIsOfficial',this.is_official);
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            } else if (this.$store.state.user_type === 1) {
                let data = {
                    user_id: this.$store.state.user_id,
                    user_type: this.$store.state.user_type,
                };
                this.$post(myDarenInfo, data)
                    .then(res => {
                        let data = res.data;
                        this.daren_name = data.name;
                        this.head_img = data.head_img;
                        this.is_auth = Number(data.is_auth);
                        this.newbie_task = Number(data.newbie_task);
                        this.auth_type = Number(data.auth_type);
                        this.is_agent = Number(data.is_agent);
                        this.$store.commit('changeAuthType',this.auth_type);
                        this.$store.commit('changeIsAuth',this.is_auth);
                        this.$store.commit('changeNewbieTask',this.newbie_task);
                        this.$store.commit('changeIsAgent',this.is_agent);
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            }
        },
        getMessage () {
            if (this.$store.state.user_type === 0) {
                let data = {
                    user_type:0,
                    user_id:this.$store.state.user_id,
                };
                this.$post(newsData,data)
                    .then(res => {
                        let data = res.data;
                        this.is_new = data.is_new;
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            } else if (this.$store.state.user_type === 1) {
                let data = {
                    user_type:1,
                    user_id:this.$store.state.user_id,
                };
                this.$post(newsData,data)
                    .then(res => {
                        let data = res.data;
                        this.is_new = data.is_new;
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            }

        },
        loginOut () {
            this.$confirm('确定要退出吗？是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.commit('changeCode' ,'');
                this.$store.commit('changeAuthToken' ,'');
                this.$store.commit('changeOpenId' ,'');
                this.$store.commit('changeUnionId' ,'');
                this.$store.commit('changeIsAuth' ,NaN);
                this.$store.commit('changeId' ,NaN);
                this.$store.commit('changeUserType' ,3);
                this.$store.commit('changeIsOperater' ,0);
                this.$store.commit('changeIsPass' ,NaN);
                this.$store.commit('changeAuthType' ,NaN);
                this.$store.commit('changeRank' ,NaN);
                this.$store.commit('changeNewbieTask' ,NaN);
                this.$store.commit('changeIsAgent' ,NaN);
                this.$store.commit('changeIsAnswer' ,NaN);
                this.$store.commit('changeIsInfo' ,NaN);
                this.$store.commit('changeWeChatNumber' ,NaN);
                this.$store.commit('changeWeChatFriendNum' ,NaN);
                this.$store.commit('changeSource' ,NaN);
                this.$store.commit('changeLabel' ,NaN);
                this.$store.commit('changeGetTime' ,NaN);
                this.$store.commit('changeIsLogin' ,NaN);
                this.$store.commit('changeIsOfficial' ,NaN);
                this.$message({
                    type: 'success',
                    message: '成功退出!'
                });
                setTimeout(() => {
                    this.$router.push('/')
                },1000)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });
            });
        },
        handelJoin (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = {
                        name: this.form.name,
                        nickname: this.form.nickname,
                        telephone: this.form.telephone,
                        area: this.form.area,
                    };
                    this.$post(addBusiness,data)
                        .then(() => {
                            setTimeout(() => {
                                this.$message.success('提交成功，我们会有工作人员与您联系，请保持电话畅通');
                            }, 1000);
                        })
                        .catch(() => {
                            setTimeout(() => {
                                this.$message.error('提交失败，请重新提交');
                            }, 100);
                        })
                }
            })
        },
        userOperateShow () {
            this.isOperate = true
        },
        userOperateHide () {
            this.isOperate = false
        },
        login () {
            this.goLogin()
        },
        handleScroll () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            scrollTop > 480 ? this.isShadow = true : this.isShadow = false;
        },
        getLogo () {
            let data = {
                key: 'pc_home_page'
            };
            this.$post(gethomepc,data)
                .then( res => {
                    let data = JSON.parse(res.data);
                    this.pcLogo = data.logo
                })
        }
    },
    mounted() {
        this.getInfo();
        this.getMessage();
        this.getLogo();
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
<style scoped>
    .logo{margin-top:19px;}
    .logo img{width: 153px;height: 32px;}
    .user-operate{right:0;top:70px;background: #fff;box-shadow: 0 0 6px rgba(0,0,0,.1);width:240px;z-index: 99;}
    .user-operate li{height: 40px;line-height: 40px;text-align: left;}
    .user-operate li span{display: block;padding:0 20px;}
    .user-operate li a{display: block;padding:0 20px;}
    .user-operate li a:hover{background: #F9F9F9;}
    .user-operate li:first-child{border-bottom: 1px #F5F5F5 solid;}
    .user-operate li:last-child{border-top: 1px #F5F5F5 solid;}
    .isNew{width:6px;height:6px;border-radius: 100%;background: #ff0000;display:inline-block;right:-10px;}
    .InvestmentHeader{background: none;box-shadow: none;position: absolute;}
    .InvestmentHeader .nav .item a{color:#fff;border-bottom:3px rgba(255,255,255,0) solid;}
    .InvestmentHeader .nav .item:hover{background: none;}
    .InvestmentHeader .nav .item a:hover{border-bottom:3px #fff solid;line-height:67px;}
    .InvestmentHeader .nav .item .active{border-bottom:3px #fff solid;line-height:67px;color:#fff;}
    .InvestmentHeader .goto{color:#fff;}
</style>
